import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import FormButton from "../../components/form/FormButton";
import FormDropdown from "../../components/form/FormDropdown";
import { withScreenContext } from "../../components/screen/ScreenContext";
import { matchCriteriaOptions } from "../../constants/filter";
import { PropTypeShapes } from "../../types";

const FILTER_CLEAR_ALL_LABEL = "Clear All";

const HeaderRow = ({ children }) => <div className="filterHeaderRow">{children}</div>;

HeaderRow.propTypes = {
  children: PropTypeShapes.elementOrArrayOrString
};

class CurrentFilterViewHeader extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.onClearAllFilterClick = this.onClearAllFilterClick.bind(this);
  }

  onClearAllFilterClick() {
    this.props.onFilterClearClick(this.props.filterId);
  }

  getMatchButton() {
    return (
      <FormDropdown
        options={matchCriteriaOptions}
        value={this.props.filterMatchCriteria}
        onChange={this.props.onChangeFilterMatchCriteria}
        className="filterMatchDropdown"
      />
    );
  }

  getClearAllButton() {
    return this.props.filterIsActive ? (
      <FormButton
        label={FILTER_CLEAR_ALL_LABEL}
        linkStyle={true}
        tabIndex={0}
        onClick={this.onClearAllFilterClick}
        className="clearAllBtn"
      />
    ) : null;
  }

  render() {
    return (
      <div className="currentFilterHeader">
        <HeaderRow>
          {this.getMatchButton()}
          {this.getClearAllButton()}
        </HeaderRow>
      </div>
    );
  }
}

CurrentFilterViewHeader.propTypes = {
  onFilterClearClick: PropTypes.func.isRequired,
  filterId: PropTypes.string.isRequired,
  filterIsActive: PropTypes.bool.isRequired,
  title: PropTypes.string,
  backText: PropTypes.string,
  filterMatchCriteria: PropTypes.string.isRequired,
  onChangeFilterMatchCriteria: PropTypes.func.isRequired,

  //#!if iOS === true
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

let exportedView = CurrentFilterViewHeader;
//#!if iOS === true
// exportedView = withScreenContext(CurrentFilterViewHeader);
//#!endif
export default exportedView;
